import { render, staticRenderFns } from "./SelectOrder.vue?vue&type=template&id=2a5e61ee&scoped=true&"
import script from "./SelectOrder.vue?vue&type=script&lang=js&"
export * from "./SelectOrder.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrder.vue?vue&type=style&index=0&id=2a5e61ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e61ee",
  null
  
)

export default component.exports